import { useQuery } from "@tanstack/react-query";

import neetoAppsApi from "../apis/neeto_apps";
import { QUERY_KEYS } from "../constants";

const useFetchNeetoApps = options =>
  useQuery({
    queryKey: [QUERY_KEYS.NEETO_APPS_LIST],
    queryFn: neetoAppsApi.fetch,
    ...options,
  });

export { useFetchNeetoApps };
